import { useEffect } from 'react';
import { invalidateCustomerActivityRefresh } from '@/utils/customerActivityRefresh';

export const PLAN_CHANGED_EVENT = 'scoutly:plan-changed';

export async function invalidatePlanDependentCaches(deps: {
  invalidateWorkspaces: () => Promise<void>;
}): Promise<void> {
  await deps.invalidateWorkspaces();
  invalidateCustomerActivityRefresh();
  window.dispatchEvent(new CustomEvent(PLAN_CHANGED_EVENT));
}

/** Refetch local data when any screen grants or revokes a plan. */
export function usePlanChangeListener(onPlanChanged: () => void | Promise<void>): void {
  useEffect(() => {
    const handler = () => {
      void onPlanChanged();
    };
    window.addEventListener(PLAN_CHANGED_EVENT, handler);
    return () => window.removeEventListener(PLAN_CHANGED_EVENT, handler);
  }, [onPlanChanged]);
}
